export const HAS_DOWNPAYMENT = {
  THIS_MONTH: 'thisMonth',
  NEXT_MONTH: 'nextMonth',
  LATER: 'later'
};

export const HAS_DOWNPAYMENT_OPTIONS = [
  { value: HAS_DOWNPAYMENT.THIS_MONTH },
  { value: HAS_DOWNPAYMENT.NEXT_MONTH },
  { value: HAS_DOWNPAYMENT.LATER }
];
